module.exports = __webpack_public_path__ + "static/img/logo_title1.63d9071.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_title1.png
// module id = 4hg/
// module chunks = 1